import moment from 'moment'

const Utils = {

  getItemAmount: item => {
    const netPrice = Utils.getItemNet(item)
    const taxPercent = item.taxPercent || 0
    return netPrice + netPrice * taxPercent / 100
  },

  getItemNet: item => {
    const rate = item.rate || 0
    const quantity = item.quantity || 0
    return rate * quantity
  },

  capitalize: value => value.charAt(0).toUpperCase() + value.slice(1),

  getBillAmountDue: invoice => invoice && (invoice.total - invoice.paid) || 0,

  getFilenameFromHeadersOrDefault: (headers, billingEntity, billingNumber) => {
    const fnHeader = headers['content-disposition']
    if (fnHeader) {
      const data = fnHeader.split(';')
      for (const chunk of data) {
        const index = chunk.indexOf('filename')
        if (chunk && index >= 0) {
          const startIndex = index + 'filename'.length + 2
          return chunk.slice(startIndex, chunk.length - 1)
        }
      }
    }
    return `${billingEntity}_${billingNumber}_${moment().format('YYYY-MM-DD')}.pdf`
  }

}

export default Utils



// WEBPACK FOOTER //
// ./src/billing/infra/Utils.js